import Link from 'next/link';
import React from 'react';

import { GoalName } from '../../__generated-gql-types__/globalTypes';
import HomeSmall from '../../assets/svgs/home-small.svg';
import { snakeCase } from '../../utils/formatters';

interface Breadcrumb {
  label: string;
  url: string;
}

export interface BreadcrumbsProps {
  breadcrumbs: Breadcrumb[];
  className?: string;
}

export const goalNameToBreadcrumbsLabel = (
  goal: GoalName,
  desktop: boolean,
) => {
  switch (goal) {
    case GoalName.CAREER:
      return `Career${desktop ? ' Coaching' : ''}`;
    case GoalName.TEST:
      return `Test Prep${desktop ? ' Coaching' : ''}`;
    default:
      return `Admissions${desktop ? ' Coaching' : ''}`;
  }
};

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  breadcrumbs,
  className,
}) => {
  return (
    <nav>
      <ol
        itemScope
        itemType="https://schema.org/BreadcrumbList"
        className={`flex flex-wrap items-center gap-1.5 text-sm uppercase tracking-wider text-leland-gray-light sm:gap-2 sm:text-base sm:normal-case sm:tracking-normal ${className}`}
      >
        <li
          itemProp="itemListElement"
          itemScope
          itemType="https://schema.org/ListItem"
        >
          <Link itemProp="item" href="/" id="breadcrumbs--root">
            <HomeSmall className="size-3.5 hover:text-leland-gray-extra-light sm:size-4" />
            <meta itemProp="name" content="Home" />
            <meta itemProp="position" content="1" />
          </Link>
        </li>
        {breadcrumbs.map((breadcrumb, index) => (
          <li
            className="flex items-center gap-1.5 sm:gap-2"
            key={breadcrumb.url}
            itemProp="itemListElement"
            itemScope
            itemType="https://schema.org/ListItem"
          >
            <span className="text-leland-gray-dark">/</span>
            <Link
              itemProp="item"
              href={breadcrumb.url}
              className="hover:text-leland-gray-extra-light"
              id={`breadcrumbs:${snakeCase(breadcrumb.label)}`}
            >
              {breadcrumb.label}
              <meta itemProp="name" content={breadcrumb.label} />
              <meta itemProp="position" content={(index + 2).toString()} />
            </Link>
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
